module.exports = "<p>image-viewer-for-editor works!</p>\n"